<dropdown-select
	*ngIf="options"
	[options]="options"
	[queryParam]="queryParam"
></dropdown-select>
